<template>
  <div class="interview_list">
    <div class="interview_list_container" v-infinite-scroll="loadMore">
      <div class="interview_list_one" v-for="(item,index) in lists" :key="index">
        <div class="interview_list_one_left">船名: {{item.shipname}}</div>
        <div class="interview_list_one_right">地点: {{item.check_place}}</div>
        <div class="interview_list_one_left">时间: {{new Date(item.check_time*1000).toLocaleString()}}</div>
        <div class="interview_list_one_right">检查员: {{item.inspector}}</div>
        <div class="interview_list_one_left">更新: {{new Date(item.utime*1000).toLocaleString()}}</div>
        <div class="interview_list_one_right"><el-tag type="primary" size="mini" @click="toRecord(item.id)">更新/查看</el-tag></div>
      </div>
      <div class="interview_list_one" v-if="!lists || lists.length<=0">
        暂无检查记录 <el-tag type="primary" size="mini" @click="toAddRecord">立即去录入</el-tag>
      </div>
    </div>
    <div class="interview_list_bottom">
      <el-button type="primary" size="small" @click="toAddRecord">新增检查记录</el-button>
    </div>
  </div>
</template>

<script>
  import { interviewRecordList,interviewRecordDel } from '../../api/api';

    export default {
        name: "InterviewList",
      data() {
        return {
          lists:[],
          page:1,
          size:10,
          loading:false
        }
      },
      mounted(){

      },
      methods:{
        toAddRecord(){
          this.$router.push('/interview/record');
        },
        toRecord(id){
          this.$router.push('/interview/record?id='+id);
        },
        loadMore() {
          if (!this.loading) {
            this.loading = true;
            interviewRecordList({'page':this.page, 'size':this.size}).then(res => {
              if (res && res.status === 0 && res.data) {
                for (let d in res.data) {
                  this.lists.push(res.data[d]);
                }
                this.page++;
              }
              this.loading = false;
            });
          }
        }
      }
    }
</script>

<style scoped>
  .interview_list {
    position:absolute;
    top:6vh;
    left:0;
    width: 100%;
    height: 94vh;
    background-color: #f7f7f7;
    text-shadow: .5px .3px .5px grey;
    overflow-y: scroll;
  }
  .interview_list_bottom {
    position:absolute;
    bottom:0;
    left:0;
    width:100%;
    height:8vh;
    line-height:6vh;
    border-top:.1vh solid grey;
    text-align:center;
  }
  .interview_list_container {
    width: 94%;
    margin: 3vh 3% 6vh 3%;
  }
  .interview_list_one {
    width:100%;
    float:left;
    height:15vh;
    line-height:15vh;
    font-size:.8rem;
    text-align:left;
    border-bottom:.1vh dashed grey;
  }
  .interview_list_one_left {
    width:50%;
    float:left;
    height:5vh;
    line-height:5vh;
    overflow-x:hidden;
  }
  .interview_list_one_right {
    width:50%;
    float:left;
    height:5vh;
    line-height:5vh;
    overflow-x:hidden;
  }
</style>



// WEBPACK FOOTER //
// src/components/interview/list.vue